module.exports = __webpack_public_path__ + "img/logo.2c1f4ba5.webp";